import { type ImpactSummaryTypes } from '../../../types';

export const MOCK_PREDEFINED_COMMENTS = [
  'Predefined option 1',
  'Predefined option 2',
  'Predefined option 3',
];

export const MOCK_REMEDIATION_FUNCTION: ImpactSummaryTypes[] = [
  {
    id: '1',
    entitlements: [
      {
        id: '1',
        title: 'Accounts Payable',
        subtitle: 'AP_ACCOUNTS_PAYABLE',
      },
      {
        id: '2',
        title: 'Vendor Management',
        subtitle: 'VM_VENDOR_MGMT',
      },
    ],
    violations: [
      {
        id: '1',
        title: 'High Privilege Account Detected',
        trustScore: 92,
        liklyHood: 'Actual',
        application: ['SAP ERP'],
        displayName: 'Jacob Eades',
        account: 1,
      },
    ],
    accounts: [
      {
        id: '1',
        name: 'Jacob Eades',
        application: ['SAP ERP'],
        displayName: 'Jacob Eades',
        lastLogInDate: new Date('2024-10-01T10:00:00Z'),
      },
      {
        id: '2',
        name: 'Sagar Gupta',
        application: ['Oracle Cloud'],
        displayName: 'Sagar Gupta',
        lastLogInDate: new Date('2024-09-28T08:45:00Z'),
      },
      {
        id: '3',
        name: 'Guy Fieri',
        application: ['Workday'],
        displayName: 'Guy Fieri',
        lastLogInDate: new Date('2024-09-20T14:30:00Z'),
      },
    ],
  },
  {
    id: '2',
    entitlements: [
      {
        id: '3',
        title: 'Financial Reports Access',
        subtitle: 'FR_REPORT_VIEW',
      },
      {
        id: '4',
        title: 'General Ledger',
        subtitle: 'GL_LEDGER_ACCESS',
      },
    ],
    violations: [
      {
        id: '2',
        title: 'Dormant Account Detected',
        trustScore: 60,
        liklyHood: 'Potential',
        application: ['Oracle Cloud'],
        displayName: 'Guy Fuller',
        account: 1,
      },
    ],
    accounts: [
      {
        id: '4',
        name: 'Guy Fuller',
        application: ['Oracle Cloud'],
        displayName: 'Guy Fuller',
        lastLogInDate: new Date('2024-07-15T11:00:00Z'),
      },
      {
        id: '5',
        name: 'Ava Chen',
        application: ['Salesforce'],
        displayName: 'Ava Chen',
        lastLogInDate: new Date('2024-08-01T12:15:00Z'),
      },
      {
        id: '6',
        name: 'Emily Tran',
        application: ['SAP ERP'],
        displayName: 'Emily Tran',
        lastLogInDate: new Date('2024-09-10T09:25:00Z'),
      },
    ],
  },
];
